module.exports = __webpack_public_path__ + "img/55_40.c43dfe29.png";